import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgOutlinedChevronRight = (props: ISvgProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <path
                d="M9.06055 16.59L13.6405 12L9.06055 7.41L10.4705 6L16.4705 12L10.4705 18L9.06055 16.59Z"
                fill="black"
            />
        </svg>
    )
}
